<template>
  <standard-dialog
    v-model="model"
    :title="$t('add_credit')"
    icon="mdi-credit-card-plus"
    max-width="500"
    :save-text="$t('save')"
    :loading="saving"
    :disabled="!valid"
    @save="submit"
    @close="resetForm"
  >
    <v-form ref="form" v-model="valid">
      <autocomplete
        :label="$t('limit')"
        v-model="selectedLimit"
        :items="limitOptions"
        item-text="text"
        item-value="value"
        :loading="limitsLoading"
        clearable
        :hide-details="false"
        :hint="selectedLimitHint"
        persistent-hint
        return-object
      />

      <text-field
        :label="$t('amount')"
        v-model="newCredit.amount"
        type="number"
        :rules="[(v) => !!v || $t('required'), (v) => v > 0 || $t('must_be_positive')]"
        required
      />

      <text-field :label="$t('note')" v-model="newCredit.note" />
    </v-form>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import hasSnackbar from "@/mixins/hasSnackbar";
import hasLimitOptions from "@/mixins/hasLimitOptions";
import axios from "@/plugins/axios";
import companyService from "@/services/company";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";

export default {
  name: "AddCreditDialog",
  components: {
    StandardDialog,
  },
  mixins: [hasModel, hasSnackbar, hasLimitOptions],
  props: {
    employee: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      valid: false,
      saving: false,
      newCredit: {
        amount: null,
        note: "",
      },
      selectedLimit: null,
      companyRestaurants: [],
    };
  },
  computed: {
    companyId() {
      return (
        this.employee?.company?.id ||
        this.$store.state.company?.id ||
        this.$route.params.id
      );
    },
  },
  async mounted() {
    await this.fetchCompanyRestaurants();
    const restaurantIds = this.companyRestaurants.map((r) => r.id);
    await this.fetchLimits(restaurantIds);
  },
  methods: {
    async fetchCompanyRestaurants() {
      if (!this.companyId) return;
      this.loading = true;
      try {
        const response = await companyService.getCompanyRestaurants(this.companyId);
        this.companyRestaurants = response.data;
      } catch (error) {
        console.error("Error fetching restaurants:", error);
        this.companyRestaurants = [];
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      if (!this.$refs.form.validate()) return;
      this.saving = true;
      try {
        await axios.post("/limits/transactions", {
          quantity: 1,
          price: this.newCredit.amount,
          notes: this.newCredit.note,
          user_id: this.employee.id,
          company_id: this.selectedLimit?.company_id,
          restaurant_id: this.selectedLimit?.restaurant_id,
          limit_id: this.selectedLimit?.id,
          date: new Date().toISOString().split('T')[0],
          limit_type: "credit",
          shift: "1-smena",
        });
        this.showSuccessSnackbar(this.$t("credit_added_successfully"));
        this.$emit("saved");
        this.model = false;
      } catch (err) {
        this.showErrorSnackbar(
          err.response?.data?.message || this.$t("error_adding_credit")
        );
      } finally {
        this.saving = false;
      }
    },
    resetForm() {
      this.newCredit = { amount: null, note: "" };
      this.selectedLimit = null;
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
  },
};
</script>

<style scoped></style>
